import { backboneViewProperties } from "../../../decorators/backbone-properties";

@backboneViewProperties({
    tagName: "div",
    template : ""
})
export class GenericRelationView extends Marionette.ItemView<any> {
    constructor(options?: Backbone.ViewOptions<any>) {
        super(options);
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/partials/generic-relation.ts